import React, { Component } from "react";

// Assets
import CalcLogo from "../../Assets/edit.svg";
import triangle1 from "../../Assets/triangle1.svg";
import triangle2 from "../../Assets/triangle2.svg";
import triangle3 from "../../Assets/triangle3.svg";
import circle1 from "../../Assets/circle1.svg";
import circle2 from "../../Assets/circle2.svg";
import circle3 from "../../Assets/circle3.svg";
import rectangle1 from "../../Assets/rectangle1.svg";
import rectangle2 from "../../Assets/rectangle2.svg";
import rectangle3 from "../../Assets/rectangle3.svg";

export default class insulinIntake extends Component {
  render() {
    return (
      <div className="Calculation_InsulinIntake">
        <img id="_1" src={triangle1} />
        <img id="_2" src={triangle2} />
        <img id="_3" src={triangle3} />
        <img id="_4" src={circle1} />
        <img id="_5" src={circle2} />
        <img id="_6" src={circle3} />
        <img id="_7" src={rectangle1} />
        <img id="_8" src={rectangle2} />
        <img id="_9" src={rectangle3} />
        <div className="Calculation_InsulinIntakeBlock">
          <div className="Calculation_InsulinIntakeTitle">
            Your Insulin In-Take Is
          </div>
          <div className="Calculation_InsulinIntakeDesc">
            Insulin in-take as per your selected diet and per-glucose level
          </div>
          <div className="Calculation_InsulinIntakeText">
            <div className="Calculation_DoseCnt">20</div>
            <div className="Calculation_DoseUnit">Units</div>
          </div>
          <div className="Calculation_PGButtons">
            <button className="Calculation_PGClear" onClick={()=> {this.props.renderPage(1)}}>Back</button>
            <button className="Calculation_PGSubmit" onClick={() => {this.props.renderPage(3)}}>Done</button>
          </div>
        </div>
      </div>
    );
  }
}
